import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {toast} from 'react-toastify';
import isEmpty from 'lodash/isEmpty';
import {ThemeContext} from '../common';
import {fetchTreasures, redeemTreasure, redeemClean} from '../../actions/treasures';
import {toggleTreasureChest} from '../../actions/panelNav';
import {appId} from '../../store';
import {LIST_PAGE_SIZE} from '../../configs/constants';
import {treasureRedeemedMessage} from '../../configs/messages';
import TreasureChestContent from '../TreasureChest/TreasureChestContent';
import TreasureChestRedeemModal from '../TreasureChest/TreasureChestRedeemModal';

class TreasureChestPanel extends Component {
  static propTypes = {
    isDisplayed: PropTypes.bool.isRequired,
    onTreasureToggle: PropTypes.func.isRequired,
    onFetchTreasures: PropTypes.func.isRequired,
    onRedeemTreasure: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    application: PropTypes.shape({
      details: PropTypes.shape({
        treasureChest: PropTypes.bool,
      }),
    }).isRequired,
    treasures: PropTypes.shape({
      redeemSuccess: PropTypes.bool.isRequired,
    }).isRequired,
    user: PropTypes.shape({
      coins: PropTypes.shape({
        gold: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
    onClose: PropTypes.func.isRequired,
  };

  static getDerivedStateFromProps(nextProps) {
    const {isTreasureRedeeming} = nextProps;
    // TODO: Get rid of undefined value here
    if (isTreasureRedeeming === undefined) {
      return null;
    }

    return {isModalOpened: Boolean(isTreasureRedeeming)};
  }

  state = {
    isModalOpened: false,
    currentTreasure: {},
  };

  onTreasureToggle = () => {
    const {isDisplayed, onTreasureToggle} = this.props;
    onTreasureToggle(!isDisplayed);
  };

  onTreasuresQuery = (params) => {
    const {
      onFetchTreasures,
      treasures: {
        hasMore,
        isTreasureListFetching,
        page: currentPage,
      },
    } = this.props;
    const {resetPage = false, query} = params;
    const page = resetPage ? 1 : currentPage;
    if (!isTreasureListFetching && (resetPage || hasMore)) {
      onFetchTreasures({
        appId,
        page,
        size: LIST_PAGE_SIZE,
        query,
      });
    }
  };

  onTreasureChestRedeem = (treasureId) => {
    const {onRedeemTreasure} = this.props;
    onRedeemTreasure({treasureId});
  };

  onTreasureSelect = (currentTreasure) => {
    this.setState({
      isModalOpened: true,
      currentTreasure,
    });
  };

  onModalClose = () => {
    this.setState({
      isModalOpened: false,
      currentTreasure: {},
    });
  };

  redeemTreasure = (id) => {
    this.onTreasureChestRedeem(id);
    this.onModalClose();
  };

  redeemToast() {
    const {treasures: {redeemSuccess}, dispatch} = this.props;
    if (redeemSuccess) {
      toast.success(treasureRedeemedMessage);
      dispatch(redeemClean());
    }
  }

  renderTreasureChest(styles) {
    const {
      onClose,
      user: {coins: {gold = 0}},
    } = this.props;
    const {isModalOpened, currentTreasure} = this.state;
    return (
      <div className="treasure-chest-panel">
        <div className="treasure-chest-panel__header" style={styles}>
          <h4>Treasure Chest</h4>
          <div>{`YakGold Balance: ${gold}`}</div>
          {
            onClose && <span className="icon icon-close" onClick={onClose}/>
          }
        </div>
        <TreasureChestContent
          isPanel
          onTreasureSelect={this.onTreasureSelect}
          onTreasuresQuery={this.onTreasuresQuery}
          {...this.props}
        />
        {!isEmpty(currentTreasure) && (
          <TreasureChestRedeemModal
            isModalOpened={isModalOpened}
            onModalClose={this.onModalClose}
            onTreasureChestRedeem={this.redeemTreasure}
            availablePoints={gold}
            {...currentTreasure}
          />
        )}
      </div>
    );
  }

  render() {
    const {isDisplayed} = this.props;
    return (
      <ThemeContext.Consumer>
        {(theme) => {
          const styles = {
            backgroundColor: theme.primaryColor,
          };

          return isDisplayed
            ? this.renderTreasureChest(styles)
            : <div/>;
        }}
      </ThemeContext.Consumer>
    );
  }
}

const mapStateToProps = ({application, treasures, user}) => ({application, treasures, user});

const bindActions = dispatch => (
  {
    onFetchTreasures: params => dispatch(fetchTreasures(params)),
    onRedeemTreasure: params => dispatch(redeemTreasure(params)),
    onTreasureToggle: params => dispatch(toggleTreasureChest(params)),
    dispatch,
  }
);

export default connect(mapStateToProps, bindActions)(TreasureChestPanel);
